import {createApp} from 'vue'
import FVLConfirmDeleteProfile from './FVLConfirmDeleteProfile'

const el = '.kb-component--fvl-confirm-delete-profile'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FVLConfirmDeleteProfileDOM)=>{
            const component = createApp(FVLConfirmDeleteProfile).use(Store)
            component.mount(FVLConfirmDeleteProfileDOM)
        })
    }
}